import React from 'react';
import { Footer as SharedFooter } from '@trustedshops/tps-seo-shared-frontend-react-components';
import { LocalesAllowedValues } from 'models/Locales';
import { useIntl } from 'react-intl';
import { addETrustedImprintLink } from 'helpers/addETrustedImprintLink';

const Footer = () => {
  const { formatMessage, messages } = useIntl();
  const translations = messages as LocalesAllowedValues;
  const footerImprintStructure = translations.FOOTER_IMPRINT_STRUCTURE;
  addETrustedImprintLink(
    footerImprintStructure,
    formatMessage({
      id: 'APP.FOOTER.IMPRINT_LINK_ETRUSTED'
    })
  );

  return (
    <SharedFooter
      translations={translations}
      footerStructure={translations.FOOTER_STRUCTURE}
      footerImprintStructure={translations.FOOTER_IMPRINT_STRUCTURE}
      legacyBehaviour
    />
  );
};

export default Footer;
